import React, { useState, useEffect } from "react";
import { createAllMissingPrintedInvoices } from "API/swesum";

import usePost from "Hooks/usePost";

import Textfield from "Components/UI/Form/Textfield";

//MUI
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";

export default function CreatePrintedInvoices() {
  const [message, setMessage] = useState("");

  const createPrintedInvoicesReq = usePost({
    mtnFunc: () => createAllMissingPrintedInvoices(),
    onError: (data) => {
      setMessage(`${data.response.statusText} (${data.response.status})`);
    },
    onSuccess: (data) => {
      setMessage(data.Message);
    },
  });

  return (
    <>
      <Typography variant="h6" sx={{ pt: 4, pb: 6 }}>
        Skapa fakturautskrifter
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield disabled label="Meddelande" value={message} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          onClick={() => createPrintedInvoicesReq.post()}
          variant="contained"
        >
          Starta
        </Button>
      </Grid>
    </>
  );
}
